// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/lightbulb_white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
}

.insightsTable {
  padding-right: 0px;
  padding-left: 15px;
  height: 500px;
  overflow: auto;
}

#CourseMapResults .spinner {
  margin: 0px !important;
  height: 20px !important;
  width: auto !important;
  text-align: left !important;
}

.insightsHeader {
  margin-top: 2px;
  line-height: 1.42857143;
  vertical-align: top;
  font-size: 12px;
  font-weight: bold;
}

.insightsPortalTooLightFontColor {
  color: #ffffff;
}

.insightsHeader h2 {
  font-size: 32px;
  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';
}

.insightsHeaderTitle {
  background-color: #ffffff;
  border-right: white 1px solid;
}

.courseListHeader {
  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';
  font-size: 20px;
  font-weight: 400;
  padding-left: 15px;
  padding-top: 3rem;
}

.courseTableHeader {
  padding-right: 0px;
}

.courseTableHeader th {
  background-color: #e4e4e4;
  font-size: 12px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-weight: bold;
}

.courseMapHeader {
  padding-left: 15px;

  padding-right: 15px;
}

.courseMapHeader div {
  border-bottom: 2px solid black;
}

#CourseMapResults .padding {
  padding-left: 15px;
}
.insightsCourses {
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
  background-color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
}

.insightsPeerCourses {
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #e4e4e4;
  background-color: #f9f9f9;
  padding-top: 8px;
  padding-bottom: 8px;
}

.ICLarge {
  padding-left: 1px;
  padding-right: 2px !important;
}

.ICSmall {
  padding-left: 0px;
  padding-right: 0px;
  text-align: center;
}

.ICXSmall {
  padding-left: 5px;
  padding-right: 5px;
}

.insightsHeaderBorderSpace {
  border-right-color: #a6a6a6;
  border-right-style: solid;
  border-right-width: 3px;
}

.peerTable {
  padding-left: 0px !important;
}

.insightsContent {
  padding-bottom: 20px;
}

.courseDescToolTip .tooltip-inner {
  background-color: #e5e5e5;
  color: #000;
  border-color: #a6a6a6;
  border-style: solid;
  border-width: 2px;
}
.tooltip.in {
  opacity: 1 !important;
}

.insightsTitle {
  background-color: white;
  padding: 2px;
}

.mapResultsFooter {
  background-color: #ffffff;
  padding-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 5px;
}

.seeFooter {
  color: #1eabe3;
  text-decoration: underline;
  font-size: 14px;
}

.seeMoreCourses {
  padding-left: 2px;
}

.totalsFooter {
  font-size: 14px;
  text-align: center;
  background-color: #1eabe3;
  color: #ffffff;
  margin-right: 0px;
  margin-left: 0px;
  padding: 10px;
}

.courseHelpTextBottom {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  font-size: 14px;
  font-weight: 400;
}

.courseHelpTextTop {
  padding-top: 3rem;
  padding-bottom: 3rem;
  padding-left: 15px;
  font-size: 14px;
  font-weight: 400;
}

.spacer {
  padding-left: 10px;
  padding-right: 40px;
}

.selectedFooter {
  padding-top: 20px;
  padding-bottom: 20px;
}

.sortorder:after {
  content: '\\25b2';
}
.sortorder.reverse:after {
  content: '\\25bc';
}

.sortorder:after {
  content: '\\25b2';
}
.sortorder.reverse:after {
  content: '\\25bc';
}

.ICExpandAssigned {
  width: 22% !important;
  text-align: center;
}

.ICExpandRank {
  width: 14% !important;
  text-align: center;
}

.ICExpandStatus {
  width: 14% !important;
  text-align: center;
}
.ICExpandPeerStatus {
  width: 14% !important;
  text-align: center;
}

#CourseMapResults input[type='checkbox']:checked + label::after {
  content: '';
  position: absolute;
  width: 1.5ex;
  height: 0.9ex;
  background: rgba(0, 0, 0, 0);
  top: 1.5ex;
  left: 0.3ex;
  border: 3px solid #1eabe3;
  border-top: none;
  border-right: none;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

/*hides the existing checkbox*/
#CourseMapResults input[type='radio'],
#CourseMapResults input[type='checkbox'] {
  position: absolute;
  left: -999em;
}

#CourseMapResults input[type='checkbox'] + label {
  position: relative;
  cursor: pointer;
}

#CourseMapResults input[type='checkbox'] + label::before {
  content: '';
  display: inline-block;
  vertical-align: -25%;
  height: 2ex;
  width: 2ex;
  background-color: white;
  border: 1px solid rgb(166, 166, 166);
  border-radius: 4px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.25);
  margin-right: 0.5em;
}

.hiddenHeaderSpacer {
  padding-right: 5px;
  visibility: hidden;
}

/* Insights Comments */
#CourseMapResults #commentContainer {
  padding-left: 15px;
}

.commentLabel {
  font-weight: normal;
  font-size: 14px;
  padding: 5px;
  border-radius: 15px 15px 0px 0px;
  margin-bottom: 0px;
}

#commentContainer .activeBackground {
  background-color: #e4e4e4;
}

#commentContainer .inactiveBackground {
  background-color: #f9f9f9;
}

#commentContainer .activeTab {
  border-top: 2px solid #e4e4e4;
}

#commentContainer .col-md-12 {
  padding-left: 0px;
}

.insightsComments {
  height: 120px;
  overflow: auto;
}

.insightsCommentCreated {
  text-align: left;
  padding-bottom: 2px;
  font-style: italic;
}

.commentContainer {
  border-bottom: 1px solid #eee;
  padding-left: 0px;
  padding-bottom: 5px;
  padding-top: 10px;
}

.commentContainer div {
  padding-left: 0px;
}

.commentContainer div div {
  padding-left: 0px;
}

.commentContainer:hover {
  background-color: #f9f9f9;
}

.deleteButton {
  text-align: right;
  display: none;
}

.deleteButtonShow {
  text-align: right;
  display: block !important;
}

.commentContainer:hover .deleteButton {
  display: block;
}
.deleteButton:hover {
  display: block;
}

.deleteImage {
  height: 25px;
}

.sureDelete {
  text-align: center;
  background-color: #1eabe3;
  border: 2px solid rgb(238, 238, 238);
  padding: 5px;
  color: white;
}

.sureDelete a {
  color: white;
}

.commentTextBox {
  padding: 5px 10px;
  border-radius: 3px !important;
  border: 1px solid #ccc !important;
  outline: 0;
  height: 100px !important;
}

.newComment {
  font-size: 14px !important;
}

.historyContainer {
  border-bottom: 1px solid #eee;
  padding-left: 0px;
  padding-bottom: 5px;
  padding-top: 10px;
}

.mapHistory {
  padding-right: 0px !important;
}

.mapHistory div {
  padding-right: 0px !important;
  padding-left: 0px;
}

.mapHistory.insightsComments {
  height: 222px !important;
}
/* END Insights Comments */

#CourseMapResults .popover {
  max-width: 500px !important;
}

.courseDescriptionPopover {
  max-width: 600px;
}

.courseDescriptionPopover .popover-content {
  padding: 0px;
}

/* start wizard styling */
.decisionMapContent {
  background-color: white;
  padding-top: 20px;
  padding-left: 2rem;
}

.decisionMapContent label {
  font-weight: normal;
  font-size: 14px;
}

.decisionMapInput {
  width: 50%;
}

.decisionMapConfirmText {
  font-weight: bold;
  background-color: white;
  padding: 20px;
  color: #1eabe3;
  margin-left: -20px !important;
}

.stepActiveText {
  color: #1eabe3 !important;
}

.insightsDecisionMapWizard {
  line-height: 1.42857143;
  vertical-align: top;
  background-color: #ffffff;
  padding-top: 10px;
  padding-bottom: 8px;
  padding-right: 0px;
}

.insightsDecisionMapWizard label {
  font-weight: normal;
  font-size: 14px;
}

.stepBarShort::before {
  left: -4.4em !important;
  width: 4.4em !important;
}

.stepBarMedium::before {
  left: -5.4em !important;
  width: 5.4em !important;
}

.stepBarLong::before {
  left: -8.3em !important;
  width: 8.3em !important;
}

#DecisionMapReport .title {
  padding-left: 30px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.reportCommentSave {
  float: right;
  margin-top: 5px;
  padding: 5px 10px !important;
}

.insightsCoursesReportComments {
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}

.insightsCoursesReportComments #commentContainer {
  background-color: white;
}

.insightsCoursesReportComments #commentContainer #commentTxtBoxContainer {
  padding-top: 8px;
}

.insightsCoursesReportComments .commentContainer {
  border-bottom: none;
}

.insightsCoursesReportComments #commentList {
  background-color: #f9f9f9;
  min-height: 150px;
}

.insightsCoursesReportComments .commentContainer div {
  padding-right: 0px;
}

.insights-table {
  background-color: #eeeeee;
}

.insights-table a {
  font-size: 12px;
}

.insights-table button {
  background-color: transparent !important;
  border: none !important;
  border-radius: 0px !important;
  padding-left: 0;
  padding-right: 0;
}

.insights-table button:hover {
  text-decoration: underline;
}

.decisionMakerLinks {
  margin-left: -15px;
  margin-right: -15px;
}

.insights-risks-table {
  border-bottom: 1px solid #ddd;
}

.insights-risks-table > tbody > tr > td.riskRating {
  background-color: #f2f2f2;
  border-left: 1px solid #cccccc;
  border-right: 1px solid #cccccc;
  color: #999999;
  padding-top: 2em;
  padding-bottom: 2em;
  text-align: center;
  vertical-align: middle;
}

.insights-risks-table > tbody > tr > td.riskRating.active {
  color: #000000;
  font-weight: bold;
}

.insights-risks-table > tbody > tr > td.riskRating.low.active {
  background-color: #66b340;
}

.insights-risks-table > tbody > tr > td.riskRating.medium.active {
  background-color: #ff9900;
}

.insights-risks-table > tbody > tr > td.riskRating.high.active {
  background-color: #ff8080;
}

.insights-risks-table > tbody > tr > td.riskRating.low:hover {
  background-color: #cbecb0;
}

.insights-risks-table > tbody > tr > td.riskRating.medium:hover {
  background-color: #fbd5b5;
}

.insights-risks-table > tbody > tr > td.riskRating.high:hover {
  background-color: #f8d1d3;
}

.insights-risks-table > tbody > tr > td.riskRating.low.active:hover {
  background-color: #66b340;
}

.insights-risks-table > tbody > tr > td.riskRating.medium.active:hover {
  background-color: #ff9900;
}

.insights-risks-table > tbody > tr > td.riskRating.high.active:hover {
  background-color: #ff8080;
}

.insightsCategory {
  padding: 2px !important;
  font-size: 20px !important;
}

.insightsCategoryArrow {
  margin-left: 45% !important;
}

.categorySpacer {
  height: 20px;
}

/* Insights Tips */
.tipsHeader {
  background-color: #1eabe3;
  padding: 5px;
  font-weight: 400;
  text-align: center;
  font-size: 24px;
  color: white;
  font-style: italic;
  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';
}

.tipsArrowDown {
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-right: 20px solid white;
  border-top: 20px solid transparent;
  background-color: #1eabe3;
  margin-left: 48%;
}

.tips {
  padding-left: 20px;
  padding-right: 20px;
}

.tipsImage {
  height: 30px;
  width: 30px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 30px;
  display: inline-block;
  vertical-align: middle;
}

.StartCreateTips {
  padding-top: 20px;
}

.StartCreateTips .tipsHeader {
  margin-left: 40px;
  margin-right: 40px;
}

.StartCreateTips .tips {
  padding-left: 50px;
  padding-right: 50px;
}

.decisionMakerAdd {
  background-color: #e4e4e4 !important;
  color: black !important;
  font-size: 12px !important;
}

.decisionMakerCannotRemove {
  cursor: not-allowed !important;
}

.decisionMakerCannotRemove.decisionMakerAdd.btn.pill:before {
  content: none !important;
}

.decisionReportTip {
  padding-top: 5px;
  font-size: 14px;
}
/* END Insights Tips */

/* START selection confirmation modal */
.selectionsModal {
  background-color: white;
  padding: 20px;
  margin-top: 20px;
}

.selectedOptions {
  padding: 20px;
}

.removeSelectionsTable tr {
  line-height: 1.42857143;
  vertical-align: top;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
}

.removeSelectionsTable td {
  padding: 10px;
}

.removeSelectionsTable a {
  font-size: 14px !important;
}

/* END selection confirmation modal */
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/insights/insights.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,iCAAiC;EACjC,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;AACA,0BAA0B;;AAE1B;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yDAAsE;EACtE,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA,sBAAsB;;AAEtB,uCAAuC;AACvC;EACE,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC","sourcesContent":["body {\n}\n\n.insightsTable {\n  padding-right: 0px;\n  padding-left: 15px;\n  height: 500px;\n  overflow: auto;\n}\n\n#CourseMapResults .spinner {\n  margin: 0px !important;\n  height: 20px !important;\n  width: auto !important;\n  text-align: left !important;\n}\n\n.insightsHeader {\n  margin-top: 2px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.insightsPortalTooLightFontColor {\n  color: #ffffff;\n}\n\n.insightsHeader h2 {\n  font-size: 32px;\n  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';\n}\n\n.insightsHeaderTitle {\n  background-color: #ffffff;\n  border-right: white 1px solid;\n}\n\n.courseListHeader {\n  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';\n  font-size: 20px;\n  font-weight: 400;\n  padding-left: 15px;\n  padding-top: 3rem;\n}\n\n.courseTableHeader {\n  padding-right: 0px;\n}\n\n.courseTableHeader th {\n  background-color: #e4e4e4;\n  font-size: 12px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  font-weight: bold;\n}\n\n.courseMapHeader {\n  padding-left: 15px;\n\n  padding-right: 15px;\n}\n\n.courseMapHeader div {\n  border-bottom: 2px solid black;\n}\n\n#CourseMapResults .padding {\n  padding-left: 15px;\n}\n.insightsCourses {\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n  background-color: #ffffff;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.insightsPeerCourses {\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #e4e4e4;\n  background-color: #f9f9f9;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.ICLarge {\n  padding-left: 1px;\n  padding-right: 2px !important;\n}\n\n.ICSmall {\n  padding-left: 0px;\n  padding-right: 0px;\n  text-align: center;\n}\n\n.ICXSmall {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.insightsHeaderBorderSpace {\n  border-right-color: #a6a6a6;\n  border-right-style: solid;\n  border-right-width: 3px;\n}\n\n.peerTable {\n  padding-left: 0px !important;\n}\n\n.insightsContent {\n  padding-bottom: 20px;\n}\n\n.courseDescToolTip .tooltip-inner {\n  background-color: #e5e5e5;\n  color: #000;\n  border-color: #a6a6a6;\n  border-style: solid;\n  border-width: 2px;\n}\n.tooltip.in {\n  opacity: 1 !important;\n}\n\n.insightsTitle {\n  background-color: white;\n  padding: 2px;\n}\n\n.mapResultsFooter {\n  background-color: #ffffff;\n  padding-bottom: 10px;\n  padding-left: 30px;\n  padding-right: 30px;\n  padding-top: 5px;\n}\n\n.seeFooter {\n  color: #1eabe3;\n  text-decoration: underline;\n  font-size: 14px;\n}\n\n.seeMoreCourses {\n  padding-left: 2px;\n}\n\n.totalsFooter {\n  font-size: 14px;\n  text-align: center;\n  background-color: #1eabe3;\n  color: #ffffff;\n  margin-right: 0px;\n  margin-left: 0px;\n  padding: 10px;\n}\n\n.courseHelpTextBottom {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 15px;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.courseHelpTextTop {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  padding-left: 15px;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.spacer {\n  padding-left: 10px;\n  padding-right: 40px;\n}\n\n.selectedFooter {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.sortorder:after {\n  content: '\\25b2';\n}\n.sortorder.reverse:after {\n  content: '\\25bc';\n}\n\n.sortorder:after {\n  content: '\\25b2';\n}\n.sortorder.reverse:after {\n  content: '\\25bc';\n}\n\n.ICExpandAssigned {\n  width: 22% !important;\n  text-align: center;\n}\n\n.ICExpandRank {\n  width: 14% !important;\n  text-align: center;\n}\n\n.ICExpandStatus {\n  width: 14% !important;\n  text-align: center;\n}\n.ICExpandPeerStatus {\n  width: 14% !important;\n  text-align: center;\n}\n\n#CourseMapResults input[type='checkbox']:checked + label::after {\n  content: '';\n  position: absolute;\n  width: 1.5ex;\n  height: 0.9ex;\n  background: rgba(0, 0, 0, 0);\n  top: 1.5ex;\n  left: 0.3ex;\n  border: 3px solid #1eabe3;\n  border-top: none;\n  border-right: none;\n  -webkit-transform: rotate(-45deg);\n  -moz-transform: rotate(-45deg);\n  -o-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n\n/*hides the existing checkbox*/\n#CourseMapResults input[type='radio'],\n#CourseMapResults input[type='checkbox'] {\n  position: absolute;\n  left: -999em;\n}\n\n#CourseMapResults input[type='checkbox'] + label {\n  position: relative;\n  cursor: pointer;\n}\n\n#CourseMapResults input[type='checkbox'] + label::before {\n  content: '';\n  display: inline-block;\n  vertical-align: -25%;\n  height: 2ex;\n  width: 2ex;\n  background-color: white;\n  border: 1px solid rgb(166, 166, 166);\n  border-radius: 4px;\n  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.25);\n  margin-right: 0.5em;\n}\n\n.hiddenHeaderSpacer {\n  padding-right: 5px;\n  visibility: hidden;\n}\n\n/* Insights Comments */\n#CourseMapResults #commentContainer {\n  padding-left: 15px;\n}\n\n.commentLabel {\n  font-weight: normal;\n  font-size: 14px;\n  padding: 5px;\n  border-radius: 15px 15px 0px 0px;\n  margin-bottom: 0px;\n}\n\n#commentContainer .activeBackground {\n  background-color: #e4e4e4;\n}\n\n#commentContainer .inactiveBackground {\n  background-color: #f9f9f9;\n}\n\n#commentContainer .activeTab {\n  border-top: 2px solid #e4e4e4;\n}\n\n#commentContainer .col-md-12 {\n  padding-left: 0px;\n}\n\n.insightsComments {\n  height: 120px;\n  overflow: auto;\n}\n\n.insightsCommentCreated {\n  text-align: left;\n  padding-bottom: 2px;\n  font-style: italic;\n}\n\n.commentContainer {\n  border-bottom: 1px solid #eee;\n  padding-left: 0px;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n\n.commentContainer div {\n  padding-left: 0px;\n}\n\n.commentContainer div div {\n  padding-left: 0px;\n}\n\n.commentContainer:hover {\n  background-color: #f9f9f9;\n}\n\n.deleteButton {\n  text-align: right;\n  display: none;\n}\n\n.deleteButtonShow {\n  text-align: right;\n  display: block !important;\n}\n\n.commentContainer:hover .deleteButton {\n  display: block;\n}\n.deleteButton:hover {\n  display: block;\n}\n\n.deleteImage {\n  height: 25px;\n}\n\n.sureDelete {\n  text-align: center;\n  background-color: #1eabe3;\n  border: 2px solid rgb(238, 238, 238);\n  padding: 5px;\n  color: white;\n}\n\n.sureDelete a {\n  color: white;\n}\n\n.commentTextBox {\n  padding: 5px 10px;\n  border-radius: 3px !important;\n  border: 1px solid #ccc !important;\n  outline: 0;\n  height: 100px !important;\n}\n\n.newComment {\n  font-size: 14px !important;\n}\n\n.historyContainer {\n  border-bottom: 1px solid #eee;\n  padding-left: 0px;\n  padding-bottom: 5px;\n  padding-top: 10px;\n}\n\n.mapHistory {\n  padding-right: 0px !important;\n}\n\n.mapHistory div {\n  padding-right: 0px !important;\n  padding-left: 0px;\n}\n\n.mapHistory.insightsComments {\n  height: 222px !important;\n}\n/* END Insights Comments */\n\n#CourseMapResults .popover {\n  max-width: 500px !important;\n}\n\n.courseDescriptionPopover {\n  max-width: 600px;\n}\n\n.courseDescriptionPopover .popover-content {\n  padding: 0px;\n}\n\n/* start wizard styling */\n.decisionMapContent {\n  background-color: white;\n  padding-top: 20px;\n  padding-left: 2rem;\n}\n\n.decisionMapContent label {\n  font-weight: normal;\n  font-size: 14px;\n}\n\n.decisionMapInput {\n  width: 50%;\n}\n\n.decisionMapConfirmText {\n  font-weight: bold;\n  background-color: white;\n  padding: 20px;\n  color: #1eabe3;\n  margin-left: -20px !important;\n}\n\n.stepActiveText {\n  color: #1eabe3 !important;\n}\n\n.insightsDecisionMapWizard {\n  line-height: 1.42857143;\n  vertical-align: top;\n  background-color: #ffffff;\n  padding-top: 10px;\n  padding-bottom: 8px;\n  padding-right: 0px;\n}\n\n.insightsDecisionMapWizard label {\n  font-weight: normal;\n  font-size: 14px;\n}\n\n.stepBarShort::before {\n  left: -4.4em !important;\n  width: 4.4em !important;\n}\n\n.stepBarMedium::before {\n  left: -5.4em !important;\n  width: 5.4em !important;\n}\n\n.stepBarLong::before {\n  left: -8.3em !important;\n  width: 8.3em !important;\n}\n\n#DecisionMapReport .title {\n  padding-left: 30px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.reportCommentSave {\n  float: right;\n  margin-top: 5px;\n  padding: 5px 10px !important;\n}\n\n.insightsCoursesReportComments {\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n\n.insightsCoursesReportComments #commentContainer {\n  background-color: white;\n}\n\n.insightsCoursesReportComments #commentContainer #commentTxtBoxContainer {\n  padding-top: 8px;\n}\n\n.insightsCoursesReportComments .commentContainer {\n  border-bottom: none;\n}\n\n.insightsCoursesReportComments #commentList {\n  background-color: #f9f9f9;\n  min-height: 150px;\n}\n\n.insightsCoursesReportComments .commentContainer div {\n  padding-right: 0px;\n}\n\n.insights-table {\n  background-color: #eeeeee;\n}\n\n.insights-table a {\n  font-size: 12px;\n}\n\n.insights-table button {\n  background-color: transparent !important;\n  border: none !important;\n  border-radius: 0px !important;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.insights-table button:hover {\n  text-decoration: underline;\n}\n\n.decisionMakerLinks {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.insights-risks-table {\n  border-bottom: 1px solid #ddd;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating {\n  background-color: #f2f2f2;\n  border-left: 1px solid #cccccc;\n  border-right: 1px solid #cccccc;\n  color: #999999;\n  padding-top: 2em;\n  padding-bottom: 2em;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.active {\n  color: #000000;\n  font-weight: bold;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.low.active {\n  background-color: #66b340;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.medium.active {\n  background-color: #ff9900;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.high.active {\n  background-color: #ff8080;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.low:hover {\n  background-color: #cbecb0;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.medium:hover {\n  background-color: #fbd5b5;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.high:hover {\n  background-color: #f8d1d3;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.low.active:hover {\n  background-color: #66b340;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.medium.active:hover {\n  background-color: #ff9900;\n}\n\n.insights-risks-table > tbody > tr > td.riskRating.high.active:hover {\n  background-color: #ff8080;\n}\n\n.insightsCategory {\n  padding: 2px !important;\n  font-size: 20px !important;\n}\n\n.insightsCategoryArrow {\n  margin-left: 45% !important;\n}\n\n.categorySpacer {\n  height: 20px;\n}\n\n/* Insights Tips */\n.tipsHeader {\n  background-color: #1eabe3;\n  padding: 5px;\n  font-weight: 400;\n  text-align: center;\n  font-size: 24px;\n  color: white;\n  font-style: italic;\n  font-family: 'Rockwell', 'Verdana', 'Arial', 'sans-serif';\n}\n\n.tipsArrowDown {\n  width: 0;\n  height: 0;\n  border-left: 20px solid white;\n  border-right: 20px solid white;\n  border-top: 20px solid transparent;\n  background-color: #1eabe3;\n  margin-left: 48%;\n}\n\n.tips {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.tipsImage {\n  height: 30px;\n  width: 30px;\n  background-image: url('../../assets/images/icons/lightbulb_white.svg');\n  background-size: 30px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.StartCreateTips {\n  padding-top: 20px;\n}\n\n.StartCreateTips .tipsHeader {\n  margin-left: 40px;\n  margin-right: 40px;\n}\n\n.StartCreateTips .tips {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.decisionMakerAdd {\n  background-color: #e4e4e4 !important;\n  color: black !important;\n  font-size: 12px !important;\n}\n\n.decisionMakerCannotRemove {\n  cursor: not-allowed !important;\n}\n\n.decisionMakerCannotRemove.decisionMakerAdd.btn.pill:before {\n  content: none !important;\n}\n\n.decisionReportTip {\n  padding-top: 5px;\n  font-size: 14px;\n}\n/* END Insights Tips */\n\n/* START selection confirmation modal */\n.selectionsModal {\n  background-color: white;\n  padding: 20px;\n  margin-top: 20px;\n}\n\n.selectedOptions {\n  padding: 20px;\n}\n\n.removeSelectionsTable tr {\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-bottom: 1px solid #ddd;\n  font-size: 14px;\n}\n\n.removeSelectionsTable td {\n  padding: 10px;\n}\n\n.removeSelectionsTable a {\n  font-size: 14px !important;\n}\n\n/* END selection confirmation modal */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
